import { ConditionalRenderer } from "components/conditonal-renderer";
import { ReactComponent as NotRequired } from "icons/not-required.svg";

import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";
import {
  checkForNotRequired,
  getMaxHeightForImage,
  getMaxHeightForImageExpand,
  getMaxHeightForImageExpandForShortSwing,
  getMaxHeightForImageForShortSwing,
  getPositionImageMaxWidth,
} from "../helpers";
import { useEffect, useRef, useState } from "react";
import { getVideoRatioDynamic } from "components/visualize-wrapper -multi/helpers";
import { ExpandAltOutlined } from "@ant-design/icons";
import { Tabs } from "../Tabs";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

export const CriticalImages = ({
  swingType,
  PValueImages,
  videoHeight,
  videoWidth,
  ExpandImages,
  setExpandCriticalImages,
  imageData,
  isDesktop,
  videoData,
  loading,
  onClickImage,
}) => {
  const screens = useBreakpoint();
  const isFullSwing =
    videoData?.swingType === "Full Swing" ||
    swingType === "Full Swing" ||
    !PValueImages?.status;
  const swingDetail = {
    deviceType: videoData?.deviceType,
    orientation: videoData?.orientation,
    swingType: videoData?.swingType,
  };

  const tabsArr = [
    {
      title: "Face On",
      key: "faceon",
    },
    {
      title: "Down The Line",
      key: "downtheline",
    },
  ];
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState("faceon");

  const visualizeSmallContainerRef = useRef(null);
  const [adjustedSmallHeight, setAdjustedSmallHeight] = useState(null);
  const [containerSmallWidthDynamic, setContainerSmallWidthDynamic] =
    useState(null);

  const PositionImageMaxWidth = getPositionImageMaxWidth(isFullSwing, screens);
  const expandPositionImageMaxWidth = isFullSwing ? 350 : 440;
  const maxAllowedSmallWidth = ExpandImages
    ? expandPositionImageMaxWidth
    : PositionImageMaxWidth;

  useEffect(() => {
    setTimeout(() => {
      if (!visualizeSmallContainerRef.current) return;

      const containerHeight = visualizeSmallContainerRef.current.clientHeight;

      if (!containerHeight || !videoHeight || !videoWidth) return;

      let tempHeight = containerHeight;
      let predictedSmallWidth = (containerHeight * videoWidth) / videoHeight;

      if (predictedSmallWidth > maxAllowedSmallWidth) {
        tempHeight = (maxAllowedSmallWidth * videoHeight) / videoWidth;
      }

      setAdjustedSmallHeight(tempHeight);

      const ratioWidth = getVideoRatioDynamic({
        height: tempHeight,
        videoHeight,
        videoWidth,
      });

      setContainerSmallWidthDynamic(ratioWidth);
    }, 1);
  }, [videoHeight, videoWidth, screens]);

  let finalImages = imageData;
  if (
    swingType === "Short Game" ||
    swingType === "Putting" ||
    swingType === "Bunker"
  ) {
    finalImages = finalImages.filter((obj) =>
      Object.keys(obj).some((k) => ["P1", "P4", "P7", "P10"].includes(k)),
    );
  }

  const notRequired =
    swingDetail?.deviceType === "IOS" &&
    swingDetail?.orientation === "Down The Line" &&
    swingDetail?.swingType === "Full Swing";

  return (
    <>
      <div
        id="images-container"
        className={`${styles.imagesContainer} ${
          !isFullSwing && !ExpandImages && PValueImages?.status
            ? styles.shortSwingImageContainer
            : ""
        }`}
        style={{
          height: "100%",
        }}
      >
        {finalImages.map((imageObj, index) => {
          const keyName = Object.keys(imageObj)[0];

          return (
            <div
              className={styles.imageContainer}
              onClick={() => {
                onClickImage(keyName);
              }}
            >
              <div
                className={styles.imageWrapper}
                key={index} // Using the index as the key
                // className={styles.imageWrapper}
                ref={visualizeSmallContainerRef}
                style={{
                  width: containerSmallWidthDynamic,
                  minHeight: ExpandImages
                    ? isFullSwing || !PValueImages?.status
                      ? getMaxHeightForImageExpand()
                      : getMaxHeightForImageExpandForShortSwing()
                    : getMaxHeightForImage(),
                  height: `${adjustedSmallHeight}px`,
                  // height: `${adjustedSmallHeight}px`,
                }}
              >
                {/*  */}
                {Object.values(imageObj)[0] ? (
                  <img
                    src={Object.values(imageObj)[0]} // Access the base64 data from the object value
                    alt=""
                    className={styles.image}
                    width={containerSmallWidthDynamic}
                    style={{ height: "inherit" }}
                  />
                ) : loading ? (
                  <></>
                ) : (
                  <ConditionalRenderer condition={!notRequired}>
                    <img
                      src="https://demofree.sirv.com/nope-not-here.jpg" // Access the base64 data from the object value
                      alt=""
                      className={styles.image}
                      width={containerSmallWidthDynamic}
                      style={{ height: "inherit", objectFit: "contain" }}
                    />
                  </ConditionalRenderer>
                )}

                <ConditionalRenderer
                  condition={
                    ((swingType === "Short Game" || swingType === "Putting") &&
                      PValueImages?.status &&
                      !["P1", "P4", "P7", "P10"]?.includes(
                        Object.keys(imageObj)[0],
                      )) ||
                    (["P8", "P9"]?.includes(Object.keys(imageObj)[0]) &&
                      notRequired)
                  }
                >
                  <div className={styles.notRequiredContainer}>
                    <span className={styles.notRequired}>
                      <NotRequired />
                      {checkForNotRequired(Object.keys(imageObj)[0])}
                    </span>
                  </div>
                </ConditionalRenderer>

                <div className={styles.positionsContainer}>
                  {pathname === "/m2c-athletics-history" ||
                  (pathname === "/m2c-launch-history" &&
                    !PValueImages?.status) ||
                  ((pathname === "/m2c-golf-history" ||
                    pathname === "/pg-history") &&
                    !PValueImages?.status)
                    ? Object.keys(imageObj)[0] + "%"
                    : Object.keys(imageObj)[0]}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
